import React from "react";

const IconArrowLeftOne = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 36 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.4844 27.1872C26.1968 27.5466 25.6724 27.6049 25.313 27.3174L16.9797 20.6507C16.782 20.4925 16.667 20.2531 16.667 20C16.667 19.7468 16.782 19.5074 16.9797 19.3492L25.3131 12.6826C25.6724 12.3951 26.1968 12.4533 26.4844 12.8127C26.7719 13.1721 26.7136 13.6965 26.3542 13.984L18.8343 20L26.3542 26.0159C26.7136 26.3034 26.7719 26.8278 26.4844 27.1872Z"
        fill="#29394D"
      />
      <rect x="11" y="12" width="1.5" height="15" fill="#29394D" />
    </svg>
  );
};

export default IconArrowLeftOne;
